import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  location: {
    city: '',
    state: '',
    country: '',
  },
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.location = action.payload; // Set the entire location object
    },
    updateCity: (state, action) => {
      console.log("actionaction",action)
      state.location.city = action.payload; // Update only the city
    },
    updateState: (state, action) => {
      state.location.state = action.payload; // Update only the state
    },
    updateCountry: (state, action) => {
      state.location.country = action.payload; // Update only the country
    },
  },
});

export const { setLocation, updateCity, updateState, updateCountry } = locationSlice.actions;
export default locationSlice.reducer;
